<script lang="ts">
    export let header:boolean = false;
</script>

<ul class="collection {header ? "with-header":""}">
    <slot/>
</ul>
